import React from "react";

const davis_jojy = () => {
  return (
    <div>
      <h1>Davis Jojy</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There were 2 rounds
        <br />
        Round 1: Aptitude round (29th September 2025)
        <br />
        Round 2: Interviews (30th September 2025)
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The interviews took place the very next day after the aptitude round on
        the 30th of September 2025.
        <br />
        Three different roles were offered and all of them had different
        interview procedures.
        <br />
        LCS: 2 Technical + 1 HR
        <br />
        MENDIX: 1 Technical + 1 (Technical + HR)
        <br />
        DM: 1 Technical
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round lasted for <strong>1 hour and 20 minutes</strong> and
        consisted of <strong>24 questions</strong>. The questions were a mix of{" "}
        <strong>general aptitude</strong> (covering logical reasoning,
        quantitative aptitude) and{" "}
        <strong>Object-Oriented Programming (OOPs)</strong> concepts.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
      </p>

      <p>
        A total of <strong>51 students</strong> were shortlisted after the
        Aptitude Round. They were further divided into different roles as
        follows:
      </p>

      <ul>
        <li>
          <p>
            <strong>LCS:</strong> 35 students
          </p>
        </li>
        <li>
          <p>
            <strong>MENDIX:</strong> 11 students
          </p>
        </li>
        <li>
          <p>
            <strong>DM:</strong> 5 students
          </p>
        </li>
      </ul>

      <p>
        The role allocation was done by the company, and students were not given
        the option to choose their preferred role.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The interviews were scheduled the very next day after the Aptitude
        Round, leaving only a short window for preparation. During this time, I
        focused on revising my projects and resume, making sure I could clearly
        explain my contributions, challenges faced, and key learnings.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>
        I appeared for the <strong>LCS role</strong>, which had a total of{" "}
        <strong>3 interview rounds</strong>:
      </p>

      <p>
        <strong>1. First Interview:</strong>
      </p>

      <ul>
        <li>
          Focused mainly on <strong>technical skills</strong> and topics
          mentioned on my resume.{" "}
        </li>
        <li>
          A few questions about personal background and general interests were
          also asked.{" "}
        </li>
        <li>
          Duration: <strong>25–30 minutes</strong>{" "}
        </li>
        <li>
          <strong>Shortlisting:</strong> Out of 35 students,{" "}
          <strong>17 were selected</strong> for the next round.
        </li>
      </ul>

      <p>
        <strong>2. Second Interview:</strong>
      </p>

      <ul>
        <li>
          <p>
            Emphasis was on <strong>projects and their implementation</strong>.
            Be well-prepared to discuss your projects in depth, as most
            questions were based on them.
          </p>
        </li>
        <li>
          <p>
            Several <strong>OOPS-related questions</strong> were also asked.
          </p>
        </li>
        <li>
          <p>
            Duration: <strong>1–1.5 hours</strong>
          </p>
        </li>
        <li>
          <p>
            <strong>Shortlisting:</strong> 9 students were selected for the HR
            round.
          </p>
        </li>
      </ul>

      <p>
        <strong>3. Third Interview (HR Round):</strong>
      </p>

      <ul>
        <li>
          <p>
            Focused on <strong>typical HR questions</strong>, such as behavioral
            and situational questions.
          </p>
        </li>
        <li>
          <p>
            Duration: <strong>20–25 minutes</strong>
          </p>
        </li>
      </ul>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviews primarily focused on DBMS (Database Management Systems)
        and OOPS (Object-Oriented Programming) concepts for me.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />I primarily used Striver’s SDE Sheet, which is excellent for DSA
        practice and interview preparation.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        <strong>Understand before you code:</strong> Read the question carefully
        and plan your approach.
        <br />
        <strong>Practice regularly:</strong> Solve problems regularly and
        consistently to improve problem-solving skills.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Several questions were asked about my projects and extracurricular
        activities, all based on the details mentioned in my resume. It’s
        important to be thoroughly familiar with everything on your resume.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Be confident in what you know and focus on understanding your concepts
        well. Avoid last-minute cramming; prepare consistently.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        <strong>Know your resume inside out:</strong> Be ready to discuss every
        project, skill, and activity you’ve listed.
        <br />
        <strong>Focus on fundamentals:</strong> Strengthen your concepts in
        OOPS, DBMS, and DSA, as these are commonly tested.
        <br />
        <strong>Practice problem-solving:</strong> Regular coding practice will
        improve both speed and accuracy.
        <br />
        <strong>Stay confident and calm:</strong> Interviews test both knowledge
        and composure, so don’t panic if a question seems tough.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 9307762819
        <br />
        <strong>Email :</strong> <a href="mailto:davisjojy8@gmail.com">davisjojy8@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/davis-jojy-6b2005302/">
          Davis Jojy
        </a>
      </p>

      <hr />
    </div>
  );
};

export default davis_jojy;
